import { render } from "./chevrons-left.vue?vue&type=template&id=00891e8f"
const script = {}
script.render = render

export default script